import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'

function formatJsonPreview(value: string, maxLength = 40) {
  try {
    const compact = JSON.stringify(JSON.parse(value))
    return compact.length > maxLength ? `${compact.slice(0, maxLength)}…` : compact
  } catch {
    return value.length > maxLength ? `${value.slice(0, maxLength)}…` : value
  }
}

function formatJsonPretty(value: string) {
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}

type JsonTableCellProps = {
  value?: string | null
  emptyLabel?: string
  previewMaxLength?: number
}

export function JsonTableCell({ value, emptyLabel = 'Not set', previewMaxLength = 40 }: JsonTableCellProps) {
  if (!value) {
    return <span className="text-muted-foreground">{emptyLabel}</span>
  }

  const preview = formatJsonPreview(value, previewMaxLength)
  const prettyValue = formatJsonPretty(value)

  return (
    <div className="min-w-0 max-w-full">
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="block w-full min-w-0 max-w-full truncate rounded-full border border-border px-2 py-1 text-left font-mono text-xs text-muted-foreground hover:text-foreground"
            title="Click to view JSON"
          >
            {preview}
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" side="bottom" className="w-[min(560px,90vw)] p-3" portal>
          <pre className="max-h-[360px] overflow-auto whitespace-pre-wrap break-all font-mono text-xs leading-5">
            {prettyValue}
          </pre>
        </PopoverContent>
      </Popover>
    </div>
  )
}
